/* eslint-disable */
const fontFace = (format, family, weight, localName, fileName) => {
    const woffFormat = `url('./fonts/${fileName}/${fileName}.woff2') format('woff2'),
        url('./fonts/${fileName}/${fileName}.woff') format('woff')`,
      ttfFormat = `url('./fonts/${fileName}.ttf') format('truetype');`

    return `@font-face {
        font-family: ${family};
        font-style: normal;
        font-weight: ${weight};
        src:
            local('${localName}'),
            ${format === 'woff' ? woffFormat : ttfFormat};
    }`
  },
  fonts = `
    ${fontFace('woff', 'Open Sans', 400, 'Open Sans', 'open-sans-400')}
	${fontFace('woff', 'Open Sans', 600, 'Open Sans Semibold', 'open-sans-600')}
	${fontFace('woff', 'Open Sans', 700, 'Open Sans Bold', 'open-sans-700')}
`

export default fonts
